import React, { useMemo, useState } from "react";
import { Page } from "../../activities/AppPage";
import usePatientsState from "../../hooks/usePatientsState";
import { isLoading } from "../../Loading";
import { STRINGS } from "../../strings";
import { AppState } from "../../system/AppState";
import { Patient } from "../../system/AppState/AppPatientsState";
import { translate } from "../../translate";
import LoadingScaffold from "../LoadingScaffold";
import ScaffoldTitle from "../Scaffold/components/ScaffoldTitle";
import Scaffold from "../Scaffold/Scaffold";
import PatientsScreen from "./PatientsScreen";
import ScaffoldSearchbar from "../ScaffoldSearchbar";
import NavbarActionButton from "../MainV2Screen/components/NavbarActionButton";
import { SearchIcon } from "../ScheduledVisits/ScheduledVisitsRNScreen";
import { List } from "../../utils/List";

type Props = {
  appState: AppState;
  onRequestNavigate: (page: Page) => void;
  onRequestAvailableVisits: () => void;
  onClickGoBack: () => void;
};

export default function PatientsActivity(props: Props) {
  const patientsState = usePatientsState(props.appState);
  const [searchQuery, setSearchQuery] = useState("");

  const filteredPatients: List<Patient> = useMemo(() => {
    if (isLoading(patientsState)) return List.empty();
    if (!searchQuery) return patientsState.patients;

    const query = searchQuery.toLowerCase();
    return patientsState.patients.filter((patient) => {
      const fullName = `${patient.firstName} ${patient.lastName}`.toLowerCase();
      return fullName.includes(query);
    });
  }, [patientsState, searchQuery]);

  if (isLoading(patientsState)) {
    return (
      <LoadingScaffold title={translate(STRINGS.PATIENTS)} onClickGoBack={props.onClickGoBack} />
    );
  }

  const handleClickPatient = (patient: Patient) => {
    props.onRequestNavigate({ type: "Patient", patientId: patient.id });
  };

  return (
    <Scaffold
      title={<ScaffoldTitle label={translate(STRINGS.PATIENTS)} />}
      onClickGoBack={props.onClickGoBack}
      extraHeader={
        <ScaffoldSearchbar
          leading={<NavbarActionButton icon={<SearchIcon />} onClick={() => {}} />}
          placeholder={translate(STRINGS.SEARCH_PATIENT)}
          onClick={() => {}}
          onFocus={() => {}}
          value={searchQuery}
          onChange={setSearchQuery}
        />
      }
    >
      <PatientsScreen
        patients={filteredPatients}
        onClickPatient={handleClickPatient}
        onRequestAvailableVisits={props.onRequestAvailableVisits}
        isSearch={!!searchQuery}
      />
    </Scaffold>
  );
}
